import { useEffect } from "react";
import { useMap } from "react-leaflet";

const WMSLayer = ({ wmsLayer, isVisible, zIndex }) => {
  const map = useMap();

  useEffect(() => {
    if (isVisible) {
      wmsLayer.addTo(map).setZIndex(zIndex);
      return () => {
        // remove the layer when the container is down
        if (map) {
          map.removeLayer(wmsLayer);
        }
      };
    }
  }, [map, wmsLayer]);

  return null;
};

export default WMSLayer;
